<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="customersService"
    [idKey]="'customerTypeId'"
    [subSectionSettings]="'deleteSettingsClientsTypes'"
/>